import { useMutation } from 'react-query';
import request from '../../../helpers/request';
import qs from 'qs';
import { useDispatch } from 'react-redux';
import downloadVoiting from '../../Voting/containers/voting-item/components/SaveVoiting/downloadVoiting';
import { message } from 'antd';
import useShowNotification from '../pages/ReportRSOPage/hooks/useShowNotification';
import { useLocation } from 'react-router-dom';
import {
  setErrorRso,
  setGetFileRso,
  setloadingFileRso,
  setValueForm,
} from '../pages/ReportRSOPage/store/actions/rsoImportActions';

const addRso = async ({ requestReportRSO, excelFile }) => {
  const queryString = qs.stringify(requestReportRSO, {
    arrayFormat: 'repeat',
    encode: true,
  });

  const res = await request.post(
    `/Meter/report_rso?${queryString}`,
    excelFile,
    'Не получилось отправить отчет РСО',
    null,
    null,
    {}
  );

  return res;
};

const useReportRsoMutation = () => {
  const dispatch = useDispatch();

  const location = useLocation();

  const showNotification = useShowNotification();

  const mutation = useMutation(addRso, {
    onMutate: () => {
      dispatch(setloadingFileRso(true));
      dispatch(setErrorRso(null));
    },

    onSettled: () => {
      const currentPath = window.location.pathname;
      const isReportPage = location.pathname.endsWith(currentPath);

      if (!isReportPage) {
        showNotification();
      }

      setTimeout(() => {
        dispatch(setloadingFileRso(false));
      }, 500);
    },

    onSuccess: (data) => {
      if (data?.success) {
        dispatch(
          setGetFileRso({
            generatedData: data?.rsoDraft?.generatedData,
            generatedFileName: data?.rsoDraft?.generatedFileName,
          })
        );
        downloadVoiting(
          data?.rsoDraft.generatedData,
          data?.rsoDraft.generatedFileName
        );
        dispatch(setValueForm(data.rsoDraft));
      }

      if (data?.state === 'Error') {
        message.error(data.message, 2);
        window.scrollTo({
          top: 0,
          behavior: 'smooth',
        });
        dispatch(setErrorRso(data.message));
      }
    },
  });

  return {
    createRso: mutation.mutateAsync,
    loading: mutation.isLoading,
    data: mutation.data,
  };
};

export default useReportRsoMutation;
